const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`efa8cbbc0f659db9f085b02e21f20523ff72defdb161e1cb19f061a58f95b7dd`, `efa8cbbc0f659db9f085b02e21f20523ff72defdb161e1cb19f061a58f95b7dd`, 1, 88), undefined, true, false, 1));
            }

            getTemplateName() {
                return `efa8cbbc0f659db9f085b02e21f20523ff72defdb161e1cb19f061a58f95b7dd`;
            }

            getSourceContext() {
                return new this.Source(``, `efa8cbbc0f659db9f085b02e21f20523ff72defdb161e1cb19f061a58f95b7dd`, ``);
            }
        }],
        [88, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/page/page.twig`, `efa8cbbc0f659db9f085b02e21f20523ff72defdb161e1cb19f061a58f95b7dd`, 1);

                this.blocks = new Map([
                    ['header', [this, 'block_header']],
                    ['content', [this, 'block_content']],
                    ['footer', [this, 'block_footer']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/page/page.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_header(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`
    <!-- standard Sky Nav component -->
    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/sky-nav/sky-nav.twig`, new Map([[`class`, `t-dark`], [`menu`, (context.has(`skyNavMenu`) ? context.get(`skyNavMenu`) : null)]]), false, false, 5));
                this.echo(`
  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`
    <!-- the Error is a full-height Cloud Cover component -->
    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`efa8cbbc0f659db9f085b02e21f20523ff72defdb161e1cb19f061a58f95b7dd`, `efa8cbbc0f659db9f085b02e21f20523ff72defdb161e1cb19f061a58f95b7dd`, 14, 87), new Map([[`class`, `c-cloud-cover--full-height`]]), false, false, 14));
                this.echo(`
  `);
            }

            block_footer(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`
    <!-- standard Ground Nav component -->
    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/ground-nav/ground-nav.twig`, new Map([[`menu`, (context.has(`menu`) ? context.get(`menu`) : null)], [`social`, (context.has(`social`) ? context.get(`social`) : null)], [`action`, (context.has(`action`) ? context.get(`action`) : null)], [`organization`, (context.has(`organization`) ? context.get(`organization`) : null)]]), false, false, 36));
                this.echo(`
  `);
            }

            getTemplateName() {
                return `efa8cbbc0f659db9f085b02e21f20523ff72defdb161e1cb19f061a58f95b7dd`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `efa8cbbc0f659db9f085b02e21f20523ff72defdb161e1cb19f061a58f95b7dd`, ``);
            }
        }],
        [87, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/cloud-cover/cloud-cover.twig`, `efa8cbbc0f659db9f085b02e21f20523ff72defdb161e1cb19f061a58f95b7dd`, 14);

                this.blocks = new Map([
                    ['heading', [this, 'block_heading']],
                    ['content', [this, 'block_content']],
                    ['scene', [this, 'block_scene']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/cloud-cover/cloud-cover.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_heading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`content`, `Your Device is Offline`], [`level`,  -2], [`class`, `heading`]]), false, false, 18));
                this.echo(`      `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        <p>Here at Cloud Four, we scout the frontier of the web to find practical uses for new technology. Like, offline web pages and progressive web apps. Sorry you have no connection at the moment. Let’s work together to make the web a good place for on and offline experiences!</p>
      `);
            }

            block_scene(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        <img class="c-cloud-cover__scene-object" src="media/sleepy-robot.svg" />
      `);
            }

            getTemplateName() {
                return `efa8cbbc0f659db9f085b02e21f20523ff72defdb161e1cb19f061a58f95b7dd`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `efa8cbbc0f659db9f085b02e21f20523ff72defdb161e1cb19f061a58f95b7dd`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'efa8cbbc0f659db9f085b02e21f20523ff72defdb161e1cb19f061a58f95b7dd');

let template = env.loadTemplate('efa8cbbc0f659db9f085b02e21f20523ff72defdb161e1cb19f061a58f95b7dd');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/error/example/offline.twig", args: context }
     );
     return rendered;;
};